<style scoped>

  .content {
    padding: 5px 20px 20px 20px !important;
  }

</style>

<template>

  <div class="ui fluid styled accordion">

    <div id="filters-button" class="title" :class="{ active }">
      <i class="dropdown icon"></i>
      Filtros
    </div>

    <div class="content" :class="{ active }">

      <form class="ui form" @submit.prevent="onSearch()" :class="{ loading }">
        <div class="fields">                    
          <div class="eight wide field">
            <label class="form-label">Produto <span class="red text">*</span></label>
            <select id="select-product" class="ui fluid search dropdown" v-model="filter.product">
              <option value="">Selecione...</option> 
              <option v-for="product in $store.state.products" :value="product.id">
                {{ product.value }}
              </option>
            </select>
          </div>
          <div class="four wide field">
            <label class="form-label">Bitola <span class="red text">*</span></label>
            <select id="select-bitola" class="ui fluid search dropdown" v-model="filter.bitola">
              <option value="">Selecione...</option>        
              <option v-for="bitola in $store.state.bitolas" :value="bitola.id">
                {{ bitola.value }}
              </option>      
            </select>
          </div>
          <div class="four wide field">
            <label class="form-label">Cor</label>
            <select id="select-color" class="ui fluid search dropdown" v-model="filter.color">
              <option value="*">Todas</option>
              <option v-for="color in $store.state.colors" :value="color.id">
                {{ color.value }}
              </option>               
            </select>
          </div>
        </div>
        <div v-if="!$isCustomerOrProspect()" class="fields">
          <div class="four wide field">
            <label class="form-label">Código</label>
            <div class="ui action input">
              <input type="text" maxlength="6" v-model="customerCode" @blur="onBlurCustomerCode()">
              <button type="button" class="ui basic icon button" @click="$refs.customerPicker.show()">
                <i class="search plus black icon"></i>
              </button>
            </div>
          </div>
          <div class="two wide field">
            <label class="form-label">Loja</label>
            <input type="text" maxlength="2" v-model="customerUnit" @blur="onBlurCustomerUnit()">
          </div>
          <div class="ten wide field">
            <label class="form-label">Razão Social</label>
            <input type="text" readonly="readonly" :value="filter.customer ? filter.customer.name : ''">
          </div>
        </div>                
        <button class="ui basic blue icon button" :class="{ disabled: disableSearchButton, loading: searching }" 
          type="submit" style="margin-top: 10px;">
          <i class="search icon"></i>
          Pesquisar
        </button>
      </form>

    </div>

    <customer-picker ref="customerPicker" @onSelect="onSelectCustomer"/>

  </div>

</template>

<script>

  import Message from "@/utils/message"
  import CustomerPicker from "@/components/customer-picker.vue"
  import { CustomerService, ProductService} from "@/services"

  export default {

    data() {
      return {
        loading: true,               
        customerCode: "",
        customerUnit: "",
        filter: {
          product: "",
          bitola: "",
          color: "*",
          customer: null,
        },        
      }
    },

    props: ["active", "searching"],

    components: {
      CustomerPicker,
    },

    computed: {

      disableSearchButton() {
        return (!this.filter.product || !this.filter.bitola)
      },
    },

    mounted() {

      $(".accordion").accordion()

      $(".ui.fluid.search.dropdown").dropdown({
        fullTextSearch: true,
      })        

      this.loadData()
    },

    methods: {

      async loadData() {

        this.loading = true

        try {

          if (this.$store.state.products.length == 0)            
            this.$store.commit("setProducts", await ProductService.getProperties("name"))

          if (this.$store.state.bitolas.length == 0)            
            this.$store.commit("setBitolas", await ProductService.getProperties("bitola"))

          if (this.$store.state.colors.length == 0)            
            this.$store.commit("setColors", await ProductService.getProperties("color"))  

          if (this.$store.state.balancesFilter) {
            this.filter = this.$cloneObject(this.$store.state.balancesFilter)      
            this.onSelectCustomer(this.$store.state.balancesFilter.customer)
          }  

          $("#select-product").dropdown("set selected", this.filter.product)
          $("#select-bitola").dropdown("set selected", this.filter.bitola)
          $("#select-color").dropdown("set selected", this.filter.color)

          this.loading = false
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onBlurCustomerCode() {

        if (!this.customerCode) {
          this.customerUnit = ""
          this.onSelectCustomer(null)
          return
        }  

        if (!this.customerUnit)
          this.customerUnit = "01"

        this.loadCustomer()
      },

      onBlurCustomerUnit() {

        if (this.customerCode && this.customerUnit)
          this.loadCustomer()
      },

      async loadCustomer() {

        this.loading = true

        try {

          let customer = await CustomerService.getByCode(this.customerCode, this.customerUnit)

          if (customer.isBlocked) {            
            customer = null            
            Message.info("Cliente bloqueado")
          } 

          this.onSelectCustomer(customer)

          this.loading = false          
          
        } catch (error) {
          
          this.loading = false
          
          this.onSelectCustomer(null)
          this.$errorHandler(error)
        }
      },

      onSelectCustomer(customer) {

        if (customer) {
          this.customerCode = customer.code
          this.customerUnit = customer.unit
          this.filter.customer = customer
        } else {          
          this.filter.customer = null
        }        

        this.$emit("onSelectCustomer", customer)
      },

      onSearch() {    

        this.$store.commit("setBalancesFilter", this.$cloneObject(this.filter))

        let data = {
          productName: this.filter.product,
          productBitola: this.filter.bitola,
          productColor: this.filter.color,
          customerCode: "",
          customerUnit: "",
          isProspect: false,
        }

        if (data.productColor == "*")
          data.productColor = ""

        if (this.$isCustomerOrProspect()) {

          data.customerCode = this.$store.state.user.customer.code
          data.customerUnit = this.$store.state.user.customer.unit
          data.isProspect = this.$store.state.user.customer.isProspect

        } else if (this.filter.customer) {

          data.customerCode = this.filter.customer.code
          data.customerUnit = this.filter.customer.unit
          data.isProspect = this.filter.customer.isProspect
        } 

        this.$emit("onSearch", data)
      },

      toggleActive() {
        $("#filters-button").click()
      },
    },
  }

</script>
